import {Component, ContentChildren, HostListener, Input, OnInit, QueryList} from '@angular/core';
import {PopinAnchorDirective} from '../popin-anchor.directive';
import {Subject, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-popin-navbar-right',
  templateUrl: './popin-navbar-right.component.html',
  styleUrls: ['./popin-navbar-right.component.scss']
})
export class PopinNavbarRightComponent implements OnInit {

  constructor() {
    this.scrollSubscription = this.subjectOnScroll
    .asObservable()
    .pipe(debounceTime(20))
    .subscribe(scrollTop => {
      this.updateActiveNavbarRight(scrollTop);
    });}

  subjectOnScroll: Subject<number> = new Subject<number>();
  private scrollSubscription: Subscription;

  private _anchors: QueryList<PopinAnchorDirective>;

  private static isScrollYAtBottom(scrollTop: number) {
    return scrollTop + window.innerHeight >= document.documentElement.offsetHeight;
  }

  private static isScrollYAtTop(scrollTop: number) {
    return scrollTop === 0;
  }

  private hasAnchors() {
    return this._anchors && this._anchors.length > 0;
  }

  updateActiveNavbarRight(scrollTop: number): void {
    if (!this.hasAnchors()) { return ; }

    if (PopinNavbarRightComponent.isScrollYAtTop(scrollTop)) {
      this.activateFirstAnchor();
    } else if (PopinNavbarRightComponent.isScrollYAtBottom(scrollTop)) {
      this.activateLastAnchor();
    } else {
      let isAlreayOneItemActive = false;
      this._anchors.forEach(item => {
        if (isAlreayOneItemActive) {
          item.isActive = false;
        } else {
          item.isActive = item.isBottomLowerThanTopClientScreen;
          isAlreayOneItemActive = item.isActive;
        }
      });
    }
  }

  private activateFirstAnchor(): void {
    if (this._anchors.length > 0) {
      const lastItem = this._anchors[0];
      this._anchors.forEach(item => {
        item.isActive = lastItem === item;
      });
    }
  }

  private activateLastAnchor(): void {
    if (this._anchors.length > 0) {
      const lastItem = this._anchors[this._anchors.length - 1];
      this._anchors.forEach(item => {
        item.isActive = lastItem === item;
      });
    }
  }

  @HostListener('window:scroll', []) onWindowScroll() {
    this.subjectOnScroll.next(document.documentElement.scrollTop);
  }

  @ContentChildren(PopinAnchorDirective, {descendants: true}) set anchors(value: QueryList<PopinAnchorDirective>) {
    this._anchors = value;
  }

  get anchors() {
    return this._anchors;
  }

  ngOnInit(): void {
  }

}
